import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LogoutIcon from '@mui/icons-material/Logout';
import Box from '@mui/material/Box';
import { useNavigate, Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useCarrito } from '../context/CarritoContext';

const Navbar = () => {
  const nombreDelUsuario = sessionStorage.getItem('Nombre');
  const navigate = useNavigate();
  const { rol } = useCarrito();

  const handleLogout = () => {
    localStorage.clear();
    localStorage.setItem('Salir', true);
    Cookies.remove('authToken');
    navigate('/login');
  };

  const handleCarrito = () => {
    navigate('/carrito');
  };

  const handleCalendario = () => {
    navigate('/agendar');
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#1a181c' }}>
      <Toolbar
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
          py: { xs: 1, sm: 0 },
          gap: { xs: 1, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1, sm: 4 },
            alignItems: 'center',
          }}
        >
          {rol !== 'Mecanico' && (
            <Typography
              variant="body1"
              component={Link}
              to="/inventario"
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              Inventario
            </Typography>
          )}
          {rol !== 'Mecanico' && (
            <Typography
              variant="body1"
              component={Link}
              to="/pedidos"
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              Pedidos
            </Typography>)}


          <Typography
            variant="body1"
            component={Link}
            to="/servicios"
            sx={{
              color: 'white',
              textDecoration: 'none',
              fontSize: { xs: '14px', sm: '16px' },
            }}
          >
            Servicios
          </Typography>
          {(rol === 'Administracion' || rol === 'Direccion') && (
            <Typography
              variant="body1"
              component={Link}
              to="/productonegado"
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              Producto Negado
            </Typography>
          )}
          {rol === 'Admin' && (
            <Typography
              variant="body1"
              component={Link}
              to="https://bibliotecadlago.com/inventario.html"
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              Pedidos TCAR
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: { xs: 1, sm: 0 },
          }}
        >
          <Box
            component="img"
            src="/logo llantas.png"
            alt="Logo"
            sx={{
              height: { xs: 30, sm: 40 },
              width: 'auto',
            }}
          />
          <Typography
            variant="body1"
            sx={{
              color: 'white',
              fontSize: { xs: '14px', sm: '16px' },
              textAlign: 'center',
            }}
          >
            Bienvenido {nombreDelUsuario}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 1, mt: { xs: 1, sm: 0 } }}>
          <IconButton color="inherit" onClick={handleCalendario} aria-label="calendario">
            <CalendarMonthIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleCarrito} aria-label="carrito">
            <ShoppingCartIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout} aria-label="logout">
            <LogoutIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
